/**
 * GOFO/CIRRO E-Commerce injection hubs accepted by EasyPost's `ParcllAccount`
 * `origin_hub` credential. EasyPost does not validate the value server-side;
 * this list mirrors the select in the EasyPost dashboard.
 */
export const GOFO_ORIGIN_HUBS = [
  { code: "EA", label: "East (Atlanta)" },
  { code: "WE", label: "West (Los Angeles)" },
  { code: "CE", label: "Central (Chicago)" },
  { code: "NE", label: "Northeast (New York)" },
  { code: "SE", label: "Southeast (Miami)" },
  { code: "SO", label: "South (Dallas)" },
  { code: "NJ", label: "New Jersey" },
  { code: "SL", label: "Salt Lake City" },
  { code: "CA", label: "Canada" },
] as const;

export type GofoOriginHubCode = (typeof GOFO_ORIGIN_HUBS)[number]["code"];

export const GOFO_BYOCA_ORIGIN_HUBS = [
  { code: "ATL", label: "Atlanta" },
  { code: "CLT", label: "Charlotte" },
  { code: "DEN", label: "Denver" },
  { code: "DFW", label: "Dallas / Fort Worth" },
  { code: "EWR", label: "Newark" },
  { code: "IAH", label: "Houston" },
  { code: "JFK", label: "New York City" },
  { code: "LAX", label: "Los Angeles" },
  { code: "MIA", label: "Miami" },
  { code: "ORD", label: "Chicago" },
  { code: "SEA", label: "Seattle" },
  { code: "SFO", label: "San Francisco" },
  { code: "SLC", label: "Salt Lake City" },
] as const;

export type GofoByocaOriginHub =
  (typeof GOFO_BYOCA_ORIGIN_HUBS)[number]["code"];
